import { useNavigate } from 'react-router-dom';
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import FlatList from 'flatlist-react';
import { baseUrlback } from '../../../urlApi';
import { useConsultarIp } from '../../../hooks/useConsultarIp';
import { Loading } from '../../../components/Loading';


export const DocPorFirmarRep = () => {


    const contraparte = JSON.parse(localStorage.getItem('dataUsuario'))
  

    const empresa  = useSelector(state => state.app.empresa)

  

    let navigate = useNavigate();

    const dispatch = useDispatch()

    const [loadingFirmarMasivo, setLoadingFirmarMasivo] = useState(false)

    
    const sid =  localStorage.getItem('sid')
    const strcon = localStorage.getItem('strcon')
    const codigo= localStorage.getItem('codigo')

    let portal = localStorage.getItem('sid')


    const [porFirmar, setporFirmar] = useState([])

    const [checkedState, setCheckedState] = useState([]);

    const {ip} = useConsultarIp()
    


    const consultarDatos = async () => {
          
        

      try {

     


          const response = await axios.get(`${baseUrlback}api/firma/sin-firmar-contraparte/${contraparte.perid}/${empresa.value}/${sid}`);
                  

          // Filtramos para que la data del rut coincida con el rut de la empresa y que ademas le toque firmar

          let responseFiltradaEmpresa = response.data.filter(item  => item.empid === empresa.value && item.flujo !== 'trabajador'  )

        //   console.log('aaaa',responseFiltradaEmpresa)

          let carpeta = responseFiltradaEmpresa.map(({link, fechaCreacion, codper, tipo,id,firmas,flujo,maxFirmas, empid, sid,emailTrabajador,emailContraparte,nombreTrabajador,conid,firmaTrabajador,emailContraparte2,idContraparte}) => {
            return {link, fechaCreacion, codper, tipo, _id:id,firmas,flujo,maxFirmas, empid,sid,emailTrabajador,emailContraparte,nombreTrabajador, conid,firmaTrabajador,emailContraparte2:emailContraparte2 ? emailContraparte2 : '', idContraparte }
           })
            

          // console.log('carpeta',carpeta)

          // if para comprobar que comprobar la simultaneidad funcione
                
                  if(JSON.stringify(carpeta) !== JSON.stringify(porFirmar)){

                    setporFirmar(carpeta)

                    
                    setCheckedState(new Array(carpeta.length).fill(false))

                  }
       
                  
              // setLoading(false)
                  
              return carpeta

          } catch (error) {
            
          alert("Error de conexion","Intentalo otra vez", );
          // setLoading(false)
              console.log(error)
          }


  }

  useEffect(() => {

    if(empresa.value && contraparte.perid){
        consultarDatos()

    }
    
  }, [empresa])


    const [seleccionados, setSeleccionados] = useState([])

  
    // console.log(porFirmar,'porFirmar')


    // console.log('seleccionados',seleccionados)

    const handleChange = (position) => {
        setTodo(false)
        // setSeleccionados([...seleccionados,item])
        const updatedCheckedState = checkedState.map((item, index) =>
        index === position ? !item : item)
    
        setCheckedState(updatedCheckedState)
    
    
      // console.log('updatedCheckedState',updatedCheckedState)
    
      let aer =  updatedCheckedState.indexOf(true)
    
      const indices = []
    
      while (aer != -1) {
        indices.push(aer);
        aer = updatedCheckedState.indexOf(true, aer + 1);
      }
    
      let final=[];
      for (let i = 0; i < indices.length; i++) {
        final[i] = porFirmar[indices[i]];
        
        // console.log('final',final)
        setSeleccionados(final)
      }
            
        //  console.log('indices',indices)
    }

    const [todo, setTodo] = useState(false)

    // console.log('TODO',todo)

    const selectAll = () => {

        setCheckedState(new Array(porFirmar.length).fill(true)) 

        
        setTodo(true)
        

    }
    const unSelectAll = () => {
        setTodo(false)
        setSeleccionados([])

        setCheckedState(new Array(porFirmar.length).fill(false)) 
        
    }
    
    const seeAllFalse = () => {
      
        const checkStatus =  checkedState.every(element => element === false);
            if(checkStatus){
                setSeleccionados([])

            }
       
    }

    useEffect(() => {
        seeAllFalse()
    }, [checkedState])

  


 



 

    // rut:rut, nombre:nombre, so:'pc', ip:ip,

    const [loading, setLoading] = useState(false)

    const firmarSeleccionados = async() => {



      // console.log('todotodo',todo)
      // console.log('seleccionados',seleccionados)

        if(!todo && seleccionados.length === 0){
     
            Swal.fire({
              icon: 'error',
                title: 'Selecciona al menos 1 documento',
                confirmButtonColor:'#2ec1db',
                
              })

            return
        }


        if(todo && porFirmar.length > 100 ){

            Swal.fire({
              icon: 'error',
                title: `Puedes seleccionar maximo 100 documentos, seleccionaste ${porFirmar.length}. `,
                confirmButtonColor:'#2ec1db',
                
              })

            return
        }

        if(!todo && seleccionados.length > 50 ){

            Swal.fire({
              icon: 'error',
                title: `Puedes seleccionar maximo 100 documentos, seleccionaste ${seleccionados.length}. `,
                confirmButtonColor:'#2ec1db',
                
              })

            return
        }

        setLoading(true)
      
        //  return

          const carpeta = await consultarDatos()

          // console.log('CARRRP',carpeta)
          // console.log('porFirmar',porFirmar)
          // console.log('SON IGUALES?',JSON.stringify(carpeta) === JSON.stringify(porFirmar))

          // Hacemos este if para comprobar la simultaneidad, si son diferentes es porque hubieron modificaciones

          if(JSON.stringify(carpeta) !== JSON.stringify(porFirmar)){

              Swal.fire({
              title: 'Algunos documentos han sido firmados mientras estabas en este modulo, hemos actualizado la lista, porfavor vuelve a seleccionar los documentos deseados para firmar',
              confirmButtonColor:'#2ec1db',
            
            })

            // setporFirmar(carpeta)
            setLoading(false)

            return
          }


          // dispatch(setLoadingFirmarMasivo(true))

        try {

            if(todo){
                // console.log('firmarporFirmar',porFirmar)

                let eliminarDoc3Firmas = porFirmar.filter( item => item.maxFirmas !== 3 )

                let doc3Firmas = porFirmar.filter( item => item.maxFirmas === 3 )
    
                const response = await axios.post(`${baseUrlback}api/firma/firma-masiva`,{
                    arregloDocs:eliminarDoc3Firmas,so:'pc',ip: ip ? ip : '-' , nombreContraparte:contraparte.nombre, idContraparte:contraparte.perid, emailContraparte:contraparte.email, empresa:empresa.label
                },{
                  headers:{
                    'sid':sid,
                    'strcon':strcon,
                    'codigo':codigo
                  }
                })

                const response3firmas = await axios.post(`${baseUrlback}api/firma/firma-masiva3`,{
                    arregloDocs:doc3Firmas,so:'pc',ip: ip ? ip : '-' , nombreContraparte:contraparte.nombre, idContraparte:contraparte.perid, emailContraparte:contraparte.email, empresa:empresa.label
                },{
                  headers:{
                    'sid':sid,
                    'strcon':strcon,
                    'codigo':codigo
                  }
                })



                    if(response.data === 'firmados' && response3firmas.data  === 'firmados' ){
                        Swal.fire({
                            title: 'Documentos Firmados',
                            confirmButtonColor:'#2ec1db',
                            
                          })
                        consultarDatos()
                        // dispatch(setLoadingFirmarMasivo(false))

                    }

                    setLoading(false)

                
    
                // console.log('response',response)
    
    
            }else{

        
              let eliminarDoc3Firmas = seleccionados.filter( item => item.maxFirmas !== 3 )

              let doc3Firmas = seleccionados.filter( item => item.maxFirmas === 3 )
    
                const response = await axios.post(`${baseUrlback}api/firma/firma-masiva`,{
                      arregloDocs:eliminarDoc3Firmas,so:'pc',ip: ip ? ip : '-' , nombreContraparte:contraparte.nombre, idContraparte:contraparte.perid, emailContraparte:contraparte.email, empresa:empresa.label
                  },{
                    headers:{
                      'sid':sid,
                      'strcon':strcon,
                      'codigo':codigo
                    }
                  }
                )
                

                const response3firmas = await axios.post(`${baseUrlback}api/firma/firma-masiva3`,{
                      arregloDocs:doc3Firmas,so:'pc',ip: ip ? ip : '-' , nombreContraparte:contraparte.nombre, idContraparte:contraparte.perid, emailContraparte:contraparte.email, empresa:empresa.label, 
                  },{
                    headers:{
                      'sid':sid,
                      'strcon':strcon,
                      'codigo':codigo
                    }
                  }
                )
        
            
                    if(response.data === 'firmados' && response3firmas.data  === 'firmados'){
                        Swal.fire({
                            title: 'Documentos Firmados',
                            confirmButtonColor:'#2ec1db',
                            
                          })
                        consultarDatos()
                        //  dispatch(setLoadingFirmarMasivo(false))

                    }

                    setLoading(false)


                }
    
                // console.log('response',response)
            

            // consultarDatos()


            
        } catch (error) {
            console.log(error)
          //  dispatch(setLoadingFirmarMasivo(false))
        

        }
        
        
         
        



    }












  return (
    <>

                    <div className='contenidoTodoTablaDocPorFirmarRep' > 
                    {/* header tabla */}

                                <div className='headerTablaDocPorFirmar' >

                                        <p className='ocultar display-none-inline ' >Fecha solicitud</p>
                                        <p>Tipo de documento</p>
                                        <p>Trabajador</p>
                                        <p>Accion</p>
                                        <p >Seleccionar</p>


                                </div>
                                

                                <div className='contenidoTablaDocPorFirmar' >


                              {
                                loading || loadingFirmarMasivo ? <Loading/> :

                                <FlatList list={porFirmar} renderItem={(item,index) => 
                                    <div key={index} className='divflatdocporfirmar' >
                                        <p className='bold ocultar display-none-inline' >{item.fechaCreacion}</p>
                                        <p className='tipo' >{item.tipo}</p>
                                        <p className='tipo bold' >{item.nombreTrabajador}</p>
                                        <p className='firmar' onClick={ () => navigate(`/firmar-pdf-representantes/${item._id}`,{ state: {rut:contraparte.perid, nombre: contraparte.nombre, email: contraparte.email} } )} > Ver - Firmar </p>
                                      
                                     

                                        <div className='containerInput' > <input className='input' type='checkbox' checked={checkedState[index]} onChange={ () => handleChange(index) }  /> </div> 
                                      
                                      

                                    
                                        


                                    </div>
                            
                            
                            
                            
                                
                                }
                                
                                renderWhenEmpty={() =>
                                    <div className='renderEmpty' >

                                       {!contraparte.perid ? <p className='renderVacio'> Representante no tiene ingresado un rut </p> : <p className='renderVacio'> No tienes documentos por firmar </p>  }
                                        {/* <p className='renderVacio'> No tienes documentos por firmar </p> */}
                                    

                                

                                    </div>
                                }
                                hasMoreItems
                                renderOnScroll
                                />


                              }
                                    
                               

                                

                                    



                                </div>


                    



                </div>



                <div className='contenedorFirmarSeleccionadosPorFirmar' >

                    {/* <button>Seleccionar todo</button> */}

                    <div className='contenedorButtonPorFirmar' >

                        <button className='selectAll' onClick={() =>  selectAll() }  >Seleccionar todos</button>
                        <button className='selectAll' onClick={() =>  unSelectAll() } >Deseleccionar todos</button>


                    </div>


                 
                    {/* <button className='firmarSeleccionado' disabled={loading} onClick={firmarSeleccionados} >Firmar seleccionados</button> */}

                    {
                       loading ? <button className='firmando' disabled={true}  >Firmando...</button>:
                    <button className='firmarSeleccionado' disabled={loading} onClick={firmarSeleccionados} >Firmar seleccionados</button> 
                    
                     
                    }
                    {/* <button className='firmarSeleccionado' disabled={ seleccionados.length >0 || todo === true ? false : true } onClick={firmarSeleccionados} >Firmar seleccionados</button> */}

                </div>






                </>

  )
}
